import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const VaccineContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Noto Sans Thai', sans-serif !important;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: normal;
    color: #666666;
  }
`;

const MainHeader = styled.div`
  background: white;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const ProfileImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const NotificationContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  margin-right: 8px;

  &:hover {
    transform: scale(1.1);
  }
`;

const BellIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' fill='%23666666'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  min-width: 16px;
  padding: 0 2px;
`;

const ProfileName = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #666;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const Header = styled.div`
  background-color: #00BBD3;
  padding: 16px 24px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  font-family: 'Noto Sans Thai', sans-serif !important;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const BackButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  cursor: pointer;
  font-size: 16px;
  color: #B0B0B0;
  font-family: 'Noto Sans Thai', sans-serif !important;
  
  &:hover {
    color: #666666;
  }
`;

const BackIcon = styled.span`
  font-size: 16px;
  color: #B0B0B0;
`;

const Content = styled.div`
  padding: 24px;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 32px;
`;

const VaccineIcon = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
`;

const TitleText = styled.h1`
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const TableContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const TableHeader = styled.div`
  background-color: #00BBD3;
  padding: 16px 20px;
  display: flex;
  color: white;
  font-weight: bold;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const HeaderColumn1 = styled.div`
  flex: 1;
  font-size: 16px;
  color: white;
`;

const HeaderColumn2 = styled.div`
  flex: 2;
  font-size: 16px;
  color: white;
`;

const TableRow = styled.div`
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  
  &:last-child {
    border-bottom: none;
  }
`;

const DateColumn = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const DetailColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const VaccineTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const VaccineSubtitle = styled.div`
  font-size: 14px;
  color: #B0B0B0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const VaccineStatus = styled.div`
  font-size: 14px;
  font-family: 'Noto Sans Thai', sans-serif !important;
  
  &.urgent {
    color: #ff4757;
  }
  
  &.completed {
    color: #2ed573;
  }
`;

const VaccineNotificationPage = () => {
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState(3);

  const handleNotificationClick = () => {
    navigate('/notifications');
  };

  const vaccineData = [
    {
      date: '23/10/25',
      title: 'วัคซีนไข้หวัดใหญ่',
      subtitle: 'มาก่อนเวลานัด 1 ชั่วโมง',
      status: 'รอดำเนินการฉีด',
      statusType: 'urgent'
    },
    {
      date: '12/6/25',
      title: 'วัคซีนป้องกันไวรัสตับอักเสบบี',
      subtitle: 'มาก่อนเวลานัด 1 ชั่วโมง',
      status: 'ฉีดสำเร็จ',
      statusType: 'completed'
    },
    {
      date: '4/2/25',
      title: 'มีนัดฉีดวัคซีนป้องกันโรคคอตีบ ไอกรน บาดทะยัก',
      subtitle: 'มาก่อนเวลานัด 1 ชั่วโมง',
      status: 'ฉีดสำเร็จ',
      statusType: 'completed'
    }
  ];

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  return (
    <VaccineContainer>
      <MainHeader>
        <HeaderLeft>
          <Logo src="./logo.png" alt="MFU Logo" />
          <HeaderTitle>MFU Wellness Center</HeaderTitle>
        </HeaderLeft>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <NotificationContainer onClick={handleNotificationClick}>
            <BellIcon />
            {notificationCount > 0 && (
              <NotificationBadge>{notificationCount}</NotificationBadge>
            )}
          </NotificationContainer>
          <ProfileContainer onClick={() => navigate('/profile-edit')}>
            <ProfileName>พงษ์ชัย</ProfileName>
            <ProfileImage src="./person.png" alt="Profile" />
          </ProfileContainer>
        </div>
      </MainHeader>

      <Header>
        แจ้งเตือนการฉีดวัคซีน
      </Header>
      
      <BackButton onClick={handleBackClick}>
        <BackIcon>‹</BackIcon>
        <span>ย้อนกลับ</span>
      </BackButton>

      <Content>
        <TitleSection>
          <VaccineIcon src="./เข็มฉีดยา.png" alt="Vaccine Icon" />
          <TitleText>นัดฉีดวัคซีนของท่าน</TitleText>
        </TitleSection>

        <TableContainer>
          <TableHeader>
            <HeaderColumn1>วันที่ฉีด</HeaderColumn1>
            <HeaderColumn2>ชื่อวัคซีน</HeaderColumn2>
          </TableHeader>
          
          {vaccineData.map((vaccine, index) => (
            <TableRow key={index}>
              <DateColumn>{vaccine.date}</DateColumn>
              <DetailColumn>
                <VaccineTitle>{vaccine.title}</VaccineTitle>
                <VaccineSubtitle>{vaccine.subtitle}</VaccineSubtitle>
                <VaccineStatus className={vaccine.statusType}>
                  สถานะ: {vaccine.status}
                </VaccineStatus>
              </DetailColumn>
            </TableRow>
          ))}
        </TableContainer>
      </Content>
    </VaccineContainer>
  );
};

export default VaccineNotificationPage;